import { render } from "./registerForm.vue?vue&type=template&id=1e9a773b&scoped=true&lang=true"
import script from "./registerForm.vue?vue&type=script&lang=js"
export * from "./registerForm.vue?vue&type=script&lang=js"

import "./registerForm.vue?vue&type=style&index=0&id=1e9a773b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9a773b"]])

export default __exports__